import type { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Badge.module.css';

type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

type Props = {
  tone?: Tone;
  withDot?: boolean;
  children: ReactNode;
  className?: string;
};

const toneClass: Record<Tone, string> = {
  neutral: styles.neutral,
  info: styles.info,
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
};

export function Badge({ tone = 'neutral', withDot, children, className }: Props) {
  return (
    <span className={clsx(styles.root, toneClass[tone], className)}>
      {withDot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
